import { render, staticRenderFns } from "./batchTagDialog.vue?vue&type=template&id=35d5258a"
import script from "./batchTagDialog.vue?vue&type=script&lang=js"
export * from "./batchTagDialog.vue?vue&type=script&lang=js"
import style0 from "./batchTagDialog.vue?vue&type=style&index=0&id=35d5258a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_5hxyaa5b57h6kqtn5hqvbk3bcu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports